module.exports = __webpack_public_path__ + "static/media/stumbleupon-circle.bebe6573.svg";